import React, {useState} from 'react';

import styles from './emdbButtom.module.less';

function EmdbButtom ({className='', label, onClick, selected=false, disabled=false}) {

  return (
    <div className={`${styles.emdbbuttom} ${className}`}>
      <div className={disabled ? styles.buttomdisable : selected ? styles.buttomselected : styles.buttom} onClick={onClick}>
        {label}
      </div>
    </div>
  );
}

export default EmdbButtom;
